module.exports = __webpack_public_path__ + "media/images/area/feature/shikoku/related/zh-hans/5-2df048631011f137ae1aadbe5f7b3897.jpg";